import { matchPath, Route, Routes, useLocation } from "react-router-dom";

import { AdminLayout, PlainLayout } from "app/router/components/Layout";
import NotFoundPage from "app/router/components/NotFoundPage";
import RequireLogin from "app/router/components/RequireLogin";
import RouteContent from "app/router/components/RouteContent";
import { ADMIN_ROUTE_PATHS } from "app/router/constants";
import LoginPageWeb from "pages/login/LoginPage";
import Redirect from "shared/api/AuthApi";

export default function AppRoutes() {
  const { pathname } = useLocation();
  const hasToken = localStorage.getItem("admintoken") !== null;
  const isKnownAdminRoute = ADMIN_ROUTE_PATHS.some((path) =>
    matchPath({ path, end: true }, pathname),
  );

  return (
    <Routes>
      <Route
        path="/login"
        element={<PlainLayout element={<LoginPageWeb />} />}
      />
      <Route
        path="/login/oauth/google"
        element={<PlainLayout element={<Redirect />} />}
      />
      <Route
        path="*"
        element={
          !hasToken ? (
            // 미로그인: 알려진/모르는 경로 구분 없이 로그인 안내 후 /login으로 이동
            <PlainLayout element={<RequireLogin />} />
          ) : isKnownAdminRoute ? (
            <AdminLayout>
              <RouteContent />
            </AdminLayout>
          ) : (
            // 로그인 상태에서 존재하지 않는 경로만 진짜 404
            <PlainLayout element={<NotFoundPage />} />
          )
        }
      />
    </Routes>
  );
}
